import React from 'react';
import styled from 'styled-components';
import { SectionTitle } from '../shared'
import briefcase from '../../assets/briefcase.svg'
import building from '../../assets/building.svg'
import hands from '../../assets/hands.svg'
import heart from '../../assets/heart.svg'
import money from '../../assets/money.svg'
import globe from '../../assets/globe.svg'

const BenefitsWrapper = styled.section`
  background-color: #002244;
  text-align: center;
  padding: 2rem 15% 4rem 15%;


  .benefits-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    justify-content: center;
  }

  .benefit-tile {
    background-color: transparent;
    border: 1px solid #fff;
    border-radius: 8px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .tile-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  .tile-icon img {
    max-width: 100%;
    max-height: 100%;
  }

  h3 {
    font-size: 20px;
    margin-bottom: 5px;
    text-align: left;
    color: #fff;
  }

  p {
    font-size: 16px;
    color: #fff;
    text-align: left;
  }

  @media (max-width: 768px) {
    .benefits-container {
      grid-template-columns: 1fr;
    }
  }
`;

const Benefits = () => {
  const benefits = [
    {
      title: 'Global Community',
      description: "The Podcast Incubator brings together creators from all parts of the world. Our cohorts have included voices from Nigeria, Qatar, the Shinnecock Nation, Alaska and more - creating a community where diverse perspectives strengthen everyone's work.",
      icon: globe,
    },
    {
      title: 'Safe Creative Space',
      description: "We're committed to building inclusive spaces for every person, centered around open, honest and considerate communication. This is where you can take creative risks and get the feedback that actually helps.",
      icon: heart,
    },
    {
      title: 'Real Feedback, Real Growth',
      description: "Get personalized editorial guidance from working podcast professionals and honest critiques from industry leaders. This isn't generic advice - it's specific feedback on your actual work that moves you forward.",
      icon: hands,
    },
    {
      title: 'Industry Connections',
      description: "We offer access to podcast conferences and connections to studios, including Spotify, iHeartRadio, and WNYC. Learn from the people making decisions in this industry.",
      icon: briefcase,
    },
    {
      title: 'Marketing That Works',
      description: "Stop throwing content into the void. Learn how to identify your ideal listener, where to find them, and how to build genuine connection rather than just chasing download numbers.",
      icon: building,
    },
    {
      title: 'Smart Monetization Strategies',
      description: "Understand the pros and cons of different revenue models - from sponsorships to subscriptions to premium content. Make informed decisions about what makes sense for your show and your goals.",
      icon: money,
    },
  ];

  return (
    <BenefitsWrapper>
      <SectionTitle color="white">Program Benefits</SectionTitle>
      <div className="benefits-container">
        {benefits.map((benefit, index) => (
          <div className="benefit-tile" key={index}>
            <div className="tile-icon">
              <img src={benefit.icon} alt="Benefit Icon" />
            </div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </BenefitsWrapper>
  );
};

export default Benefits;
